import { render, staticRenderFns } from "./newFactoryLabel.vue?vue&type=template&id=4c24c32a&scoped=true"
import script from "./newFactoryLabel.vue?vue&type=script&lang=js"
export * from "./newFactoryLabel.vue?vue&type=script&lang=js"
import style0 from "./newFactoryLabel.vue?vue&type=style&index=0&id=4c24c32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24c32a",
  null
  
)

export default component.exports